export const AllowedPaymentMethods = [
  "Sendola ACH",
  "PayPal",
  "Venmo",
];
